import { createTimeInput, formatDateInput } from '../Helpers/DatatableHelpers';
import { dateEditRenderer } from '../Helpers/Editors';
import moment from 'moment';
import * as DataFormat from '../../../../../Common/Scripts';

const ScriptDates = onStartEdit => [
	{
		dataField: 'type',
		text: 'Type',
		headerClasses: 'th-td-xs',
		classes: 'tr-td-overflow-hide',
		editable: false
	},
	{ dataField: 'markingTeamId', text: 'Id', hidden: true, editable: false },
	{
		dataField: 'title',
		text: 'Marking Team Title',
		headerClasses: 'th-title-td',
		sort: true,
		editable: false
	},
	{
		dataField: 'markingTeamCode',
		text: 'Code',
		headerClasses: 'th-td-sm',
		classes: 'tr-td-overflow-hide',
		sort: true,
		editable: false,
		csvFormatter: cell => DataFormat.writeDataWithLeadingZeroInCsv(cell)
	},
	{
		dataField: 'markingMethodCurrentYear',
		text: 'Marking Method',
		headerClasses: 'th-td-ml',
		classes: 'tr-td-overflow-hide',
		editable: false
	},
	{
		dataField: 'scriptDeliveryDate',
		text: 'Delivery Date',
		headerClasses: 'th-td-sm',
		classes: 'tr-td-overflow-hide',
		sort: true,
		formatter: cell => createTimeInput(cell),
		editable: false,
		csvFormatter: cell => (cell ? moment(cell).format('DD/MM/YYYY') : '')
	},
	{
		dataField: 'scriptReturnDate',
		text: 'Return Date',
		headerClasses: 'th-td-sm',
		classes: 'tr-td-overflow-hide',
		sort: true,
		formatter: cell => createTimeInput(cell),
		editable: false,
		csvFormatter: cell => (cell ? moment(cell).format('DD/MM/YYYY') : '')
	},
	{
		dataField: 'eMarkingStartDate',
		text: 'E-Marking Start Date',
		headerClasses: 'th-td-ml',
		classes: 'tr-td-overflow-hide',
		sort: true,
		formatter: formatDateInput,
		editorRenderer: dateEditRenderer(onStartEdit, 'E-Marking Start Date'),
		csvFormatter: cell => (cell ? moment(cell).format('DD/MM/YYYY') : '')
	},
	{
		dataField: 'eMarkingEndDate',
		text: 'E-Marking End Date',
		headerClasses: 'th-td-ml',
		classes: 'tr-td-overflow-hide',
		sort: true,
		formatter: formatDateInput,
		editorRenderer: dateEditRenderer(onStartEdit, 'E-Marking End Date'),
		csvFormatter: cell => (cell ? moment(cell).format('DD/MM/YYYY') : '')
	}
];

export default ScriptDates;
